import { render, staticRenderFns } from "./ExternalFooter.vue?vue&type=template&id=1d84292c&scoped=true&"
import script from "./ExternalFooter.vue?vue&type=script&lang=js&"
export * from "./ExternalFooter.vue?vue&type=script&lang=js&"
import style0 from "./ExternalFooter.vue?vue&type=style&index=0&id=1d84292c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84292c",
  null
  
)

export default component.exports